import { FC } from 'react';
import { IconButton } from '@chakra-ui/react';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';

type Props = {
  type: 'left' | 'right';
  onClick: () => void;
};

const IconsMap = {
  left: <MdChevronLeft size="30px" />,
  right: <MdChevronRight size="30px" />,
};

export const OrderNavButton: FC<Props> = ({ type, onClick }) => {
  return (
    <IconButton
      isRound
      size="lg"
      zIndex={5}
      variant="outline"
      position="absolute"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        onClick();
      }}
      icon={IconsMap[type]}
      alignSelf="center"
      aria-label="order-nav-butto"
      left={type === 'left' ? '-65px' : undefined}
      right={type === 'right' ? '-65px' : undefined}
      top="45%"
    />
  );
};
